import React from 'react'

import BackLink from '../BackLink'
import DonationLine from '../DonationLine'
import PageHeader from '../PageHeader'
import PaypalButton from '../PaypalButton'
import Tipping from '../Tipping'

// Payment step for PayPal and Venmo. The PaypalButton is the submit
// itself — clicking it opens the PayPal/Venmo SDK sheet and confirms
// directly with PayPal, no separate "Donate" button needed. Back
// button stacks below it as a secondary, full-width action.
//
// PayPal-specific fallback: when the partner has disabled both
// tipping (tipping.type == 'none') and cover-costs, Tipping renders
// nothing. AP/GP fall back to the wallet sheet's own breakdown,
// Stripe to the submit button's total/recurrence text — the
// PayPal/Venmo SDK button doesn't show any amount until the sheet
// opens, so we drop in DonationLine to keep the page from feeling
// like just a button.
const PaypalPayment = ({
  i18n, donation, paymentMethod, partnerItem, project, multiOrg, multiProject,
  tippingEnabled, coverCostsEnabled, pledgeCoversFees,
  paypal, paypalConfig, paypalSdk, paypalSdkError, multiOrgModal,
  onBack,
}) => {
  const errorMessage = paypal.errors?.base?.[0] ||
    (paypalSdkError && i18n.t('payment_methods.unavailable', {
      method: paymentMethod == 'venmo' ? 'Venmo' : 'PayPal',
    }))
  const showsControls = tippingEnabled || coverCostsEnabled

  return (
    <div className="space-y-4">
      <PageHeader heading={i18n.t('steps.payment.heading')} />
      {showsControls ? (
        <Tipping
          i18n={i18n}
          donation={donation}
          partnerItem={partnerItem}
          tippingEnabled={tippingEnabled}
          coverCostsEnabled={coverCostsEnabled}
          pledgeCoversFees={pledgeCoversFees}
        />
      ) : (
        <DonationLine
          i18n={i18n}
          donation={donation}
          partnerItem={partnerItem}
          project={project}
          multiOrg={multiOrg}
          multiProject={multiProject}
          multiOrgModal={multiOrgModal}
        />
      )}

      {errorMessage && (
        <p
          role="alert"
          className="rounded border border-danger-300 bg-danger-50 text-danger-800 p-3 text-sm"
        >
          {errorMessage}
        </p>
      )}

      <div className="space-y-2">
        {!paypalSdkError &&
          <PaypalButton
            i18n={i18n}
            donation={donation}
            paypal={paypal}
            paypalConfig={paypalConfig}
            partnerItem={partnerItem}
            paymentMethod={paymentMethod}
            paypalSdk={paypalSdk}
          />
        }
        <BackLink i18n={i18n} onClick={onBack} />
      </div>
    </div>
  )
}

export default PaypalPayment
